import { useState, useCallback } from "react";
import { getLoggedInUserAdmissionNo } from "../../../modules/common/user/UserService";
import { getPaymentHistory } from "../services/feePaymentService";
import { StudentPOStatusShort } from "../types";

export const usePaymentHistory = () => {
  const [admissionNo] = useState<string>(getLoggedInUserAdmissionNo());
  const [payments, setPayments] = useState<StudentPOStatusShort[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPayments = useCallback(async () => {
    try {
      setLoading(true);
      const data = await getPaymentHistory(admissionNo);
      setPayments(data);
    } catch (err) {
      setError("Failed to fetch payment history.");
    } finally {
      setLoading(false);
    }
  }, [admissionNo]);

  return { fetchPayments, payments, loading, error };
};
